import { feedbotToast } from '../../lib/feedbotToast'

export const toastNotifyTooLargeFilesError = (count: number) => {
  const id = 'entityTooLarge'
  const title = `${count === 1 ? 'File is' : 'Files are'} too large`
  const content = `Failed to upload too large ${count === 1 ? 'file' : 'files'}, limit is 10 MB`

  feedbotToast.error({ title, content, id })
}

export function toastNotifyPathDeleteSuccess(path: string) {
  feedbotToast.success({
    id: 'pathDeleteSuccess',
    title: `Path ${path} deleted`,
    content:
      'Documents in path were deleted. Re-index the knowledge base to remove them from index.'
  })
}
